import i18n from "../../i18n";
import en from "./locales/en.json";
import ua from "./locales/ua.json";

i18n.addResourceBundle("en", "Redgerlab", en, true, true);
i18n.addResourceBundle("ua", "Redgerlab", ua, true, true);
